import type { Hydratable } from '@vimcar/mvvm/hydratable'

import * as dataMapper from '@vimcar/mvvm/dataMapper'
import hydratable from '@vimcar/mvvm/hydratable'
import * as mobx from 'mobx'

import type { Nodes, ContentType } from '../'
import type { LinkGroup } from '../LinkGroup'
import type { NodeLink } from '../NodeLink'

type _SelectNode = {
  id: string
  title: string
  text: string
  subtext: string
  centeredText: boolean
  highlightText: boolean
  radios: boolean
  allowBack: boolean
  disableSearch: boolean
  index?: number | null
  _options: Array<{ sys: { id: string } }>
  _linkGroup: { sys: { id: string } }
  contentModelType: ContentType
  options: Array<NodeLink>
  linkGroup?: LinkGroup | null
}

// @ts-expect-error@2314
export type SelectNode = Hydratable<_SelectNode, object>

type Options = { nodes: Nodes }

const mkSelectNode = hydratable(
  ({ nodes }: Options) => {
    const selectNode = mobx.observable({
      contentModelType: 'selectNode',
      get options() {
        const optionIds =
          selectNode._options && selectNode._options.map((o) => o.sys.id)
        return (
          selectNode._options &&
          nodes.nodeLinks
            .values()
            .filter((link) =>
              selectNode._options.some((ref) => ref.sys.id === link.id),
            )
            .sort(
              (link1, link2) =>
                optionIds.indexOf(link1.id) - optionIds.indexOf(link2.id),
            )
        )
      },
      get linkGroup() {
        return selectNode._linkGroup && nodes.get(selectNode._linkGroup.sys.id)
      },
    } as _SelectNode)
    return selectNode
  },
  'SelectNode',
  {
    fields: dataMapper.lift({
      options: '_options',
      linkGroup: '_linkGroup',
    }),
    sys: dataMapper.lift({
      id: true,
    }),
  },
)

export default mkSelectNode
